import { render, staticRenderFns } from "./supportPage.vue?vue&type=template&id=0d2103ac&scoped=true"
import script from "./supportPage.vue?vue&type=script&lang=js"
export * from "./supportPage.vue?vue&type=script&lang=js"
import style0 from "./supportPage.vue?vue&type=style&index=0&id=0d2103ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2103ac",
  null
  
)

export default component.exports